import React from 'react';
import PropTypes from 'prop-types';
import Table from '../Table';
import Form from '../Form';

class InputsTableRow extends React.PureComponent {
  static propTypes = {
    data: PropTypes.shape({
      id: PropTypes.string.isRequired,
      errors: PropTypes.object,
    }).isRequired,
    columns: PropTypes.array,
    onChange: PropTypes.func,
    empty: PropTypes.bool,
  };

  static defaultProps = {
    columns: [],
  };

  handleChange = (event, props) => {
    const { onChange, data } = this.props;
    onChange(event, { ...props, id: data.id });
  }

  checkIfDisabled = (disabledBy) => {
    /* istanbul ignore else */
    if (!disabledBy) return false;

    const { data } = this.props;

    if (Array.isArray(disabledBy)) {
      let result = false;
      for (let i = 0; i < disabledBy.length; i += 1) {
        const name = disabledBy[i];
        const neg = name && name[0] === '!';
        if (neg) {
          /* istanbul ignore else */
          if (!data[name.substring(1)]) {
            result = true;
            break;
          }
        } else if (data[name]) {
          result = true;
          break;
        }
      }
      return result;
    }
    const neg = disabledBy && disabledBy[0] === '!';
    const name = neg ? disabledBy.substring(1) : disabledBy;
    return neg ? !data[name]: data[name];
  }

  render() {
    const { data, columns, empty } = this.props;
    return (
      <Table.Row>
        { columns.map((col) => {
          const { renderer: Renderer, name, disabledBy, style } = col;
          const { id, errors } = data;
          const inputName = `${id}.${name}`;
          return (
            <Table.Cell key={name + data.id} verticalAlign="top">
              <Form.Field className={style}>
                <Renderer
                  value={data[name]}
                  disabled={this.checkIfDisabled(disabledBy)}
                  name={inputName}
                  onChange={this.handleChange}
                  aria-label={inputName}
                  title={name}
                  error={errors && errors[name]}
                  data={data}
                  empty={empty}
                />
              </Form.Field>
            </Table.Cell>
          );
        })}
      </Table.Row>
    );
  }
}

export default InputsTableRow;
